var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#549457"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.243,
    height: 28.243,
    transform: "translate(15.8286 16.0044)",
    fill: "#549457"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2113 27.7716C21.1631 27.7716 21.1241 27.8107 21.1241 27.8589V37.0988C21.1241 37.1469 21.1631 37.186 21.2113 37.186H23.4777V27.7716H21.2113ZM21.2113 25.418H25.8313V39.5396H21.2113C19.8633 39.5396 18.7705 38.4468 18.7705 37.0988V27.8589C18.7705 26.5108 19.8633 25.418 21.2113 25.418ZM25.8313 26.9797V37.1433C29.6743 38.3292 32.9281 38.6445 35.5887 38.1139C37.368 37.7591 38.2301 37.1073 38.5753 36.2257C38.7531 35.7716 38.7918 35.3369 38.7692 34.57C38.7625 34.3402 38.7614 34.2985 38.7614 34.202V27.7716C38.7614 27.3261 37.9189 26.5948 37.1867 26.5948H31.7153C31.066 26.5948 30.5394 26.0689 30.5385 25.4196L30.533 21.2032C30.5329 21.165 30.508 21.1313 30.4715 21.12L29.3126 20.7617C28.7535 20.5889 28.1562 20.8799 27.9478 21.4267L25.8313 26.9797ZM37.1867 24.2413C39.1505 24.2413 41.115 25.9463 41.115 27.7716V34.202C41.115 34.2646 41.1159 34.3017 41.1218 34.5009C41.153 35.5637 41.0916 36.2544 40.7669 37.0838C40.1119 38.7569 38.5757 39.9181 36.049 40.422C32.7568 41.0786 28.8364 40.6339 24.2828 39.118C23.802 38.958 23.4777 38.5082 23.4777 38.0015V26.7631C23.4777 26.6198 23.5038 26.4778 23.5548 26.3439L25.7486 20.5885C26.399 18.8819 28.2629 17.9737 30.0077 18.5131L31.1666 18.8714C32.1881 19.1872 32.8851 20.131 32.8865 21.2001L32.8906 24.2413H37.1867Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.94035202d0e27bf4709a20830082de80.svg";
export { ForwardRef as ReactComponent };